<div class="tree-grid" [style.--column-count]="(getColumnsForLevel(0) | keyvalue).length" style="position: relative;">
  <!-- Header row -->
  <div class="tree-header tree-header-top">
    <!-- <div class="col">rootLabel</div> -->
    @for (col of getColumnsForLevel(0) | keyvalue: originalOrder; track col.key) {
    <ng-container *ngIf="!col.value.hideHeader">
      <div class="col" [class]="col.value.classes">
        <ng-container *ngIf="getHeaderTemplate(col.key, 0) as headerTemplate; else defaultHeader">
          <ng-container *ngTemplateOutlet="
                  headerTemplate;
                  context: { $implicit: col.value, header: col.value.value, node: col }
                ">
          </ng-container>
        </ng-container>
        <ng-template #defaultHeader>
          <div class="col">{{ col.value.value }}</div>
        </ng-template>
      </div>
    </ng-container>
    <!-- <div class="col">{{ col.value.value }}</div> -->
    }
  </div>
  <!-- Top-level nodes -->
  <ng-container *ngFor="let node of nodes; trackBy: trackNode">
    <ng-container *ngTemplateOutlet="nodeTemplate; context: { $implicit: node, level: 0 }">
    </ng-container>
  </ng-container>
  @if (! nodes.length) {
  <div class="tree-node level-0 tree-empty" [style.--level]="0">
    <div class="node-row">
      <div class="col col-label">
        <ng-container *ngIf="getEmptyResultsTemplate() as emptyResults; else defaultEmpty">
          <ng-container *ngTemplateOutlet="emptyResults; context: { $implicit: nodes }"></ng-container>
        </ng-container>
      </div>
    </div>
  </div>

  <ng-template #defaultEmpty>
    Empty
  </ng-template>
  }

  <!-- Recursive node template -->
  <ng-template #nodeTemplate let-node let-level="level">
    <div class="tree-node" [style.--level]="level" [class]="'level-' + level" @treeNodeRemove>
      <div class="node-row">
        <div class="col col-label">
          <!-- Expand/collapse toggle -->
          <button *ngIf="node.children?.length" class="toggle-btn" type="button" (click)="toggleNode(node, $event)">
            <mat-icon class="material-symbols-outlined">{{ node.expanded !== false ? 'expand_circle_down' :
              'expand_circle_right' }}</mat-icon>
          </button>

          @let titleCol = getTitleColumnForLevel(level);
          @if (titleCol) {
          <ng-container *ngIf="getTemplate(titleCol.key, level) as titleTemplate; else defaultTitle">
            <ng-container *ngTemplateOutlet="
                    titleTemplate;
                    context: { $implicit: node, node: node }
                  ">
            </ng-container>
          </ng-container>
          <ng-template #defaultTitle [class]="titleCol.classes">
            {{ node[titleCol.key] }}
          </ng-template>
          }
        </div>
        @for (col of getColumnsForLevel(level) | keyvalue: originalOrder | slice:1; track col.key) {
        <div class="col" *ngIf="!col.value.hideCell" [class]="col.value.classes">
          <ng-container *ngIf="getTemplate(col.key, level) as cellTemplate; else defaultCell">
            <ng-container *ngTemplateOutlet="
                  cellTemplate;
                  context: { $implicit: node, node: node }
                ">
            </ng-container>
          </ng-container>
          <ng-template #defaultCell>
            {{ node[col.key] }}
          </ng-template>
        </div>
        }
      </div>

      <ng-template #nodeHeaderTemplate let-node let-level="level">
        <div class="tree-header" [style.--level]="level">
          @for (col of getColumnsForLevel(level) | keyvalue: originalOrder; track col.key) {
          <div class="col" *ngIf="!col.value.hideHeader" [class]="col.value.classes">
            <ng-container *ngIf="getHeaderTemplate(col.key, level) as headerTemplate; else defaultHeader">
              <ng-container *ngTemplateOutlet="
                  headerTemplate;
                  context: { $implicit: col.value, node: node, header: col.value.value }
                ">
              </ng-container>
            </ng-container>
            <ng-template #defaultHeader>
              {{ col.value.value }}
            </ng-template>
          </div>
          }
        </div>
      </ng-template>

      <ng-template #nodeFooterTemplate let-node let-level="level">
        <div class="tree-footer" [style.--level]="level">
          @for (col of getColumnsForLevel(level) | keyvalue: originalOrder; track col.key) {
          <div class="col" [style.grid-column]="'span ' + (col.value.span ?? 1)" [class]="col.value.classes"
            *ngIf="!col.value.hideFooter">
            <ng-container *ngIf="getFooterTemplate(col.value.key, level) as footerTemplate; else defaultFooter">
              <ng-container *ngTemplateOutlet="
                  footerTemplate;
                  context: { $implicit: col.value, node: node, footer: col.value }
                ">
              </ng-container>
            </ng-container>
            <ng-template #defaultFooter>
              {{ col.value.value }}
            </ng-template>
          </div>
          }
        </div>
      </ng-template>

      <!-- Children (only when expanded) -->
      <div class="children"
        *ngIf="node.expanded && (node.children?.length || node.renderChildFooter || node.renderChildHeader)">
        @if (node.renderChildHeader) {
        <!-- <div class="tree-header">
            @for (col of getColumnsForLevel(level+1) | keyvalue; track col) {
              <div class="col">{{ col.value }}</div>
            }
          </div> -->
        <ng-container *ngTemplateOutlet="nodeHeaderTemplate; context: { $implicit: node, level: level + 1 }">
        </ng-container>
        }
        <ng-container *ngFor="let child of node.children; trackBy: trackNode">
          <ng-container *ngTemplateOutlet="nodeTemplate; context: { $implicit: child, level: level + 1 }">
          </ng-container>
        </ng-container>
        @if (node.renderChildFooter) {
        <!-- <div class="tree-header">
            @for (col of getColumnsForLevel(level+1) | keyvalue; track col) {
              <div class="col">{{ col.value }}</div>
            }
          </div> -->
        <ng-container *ngTemplateOutlet="nodeFooterTemplate; context: { $implicit: node, level: level + 1 }">
        </ng-container>
        }
      </div>
    </div>
  </ng-template>
</div>
